import React, { Component } from "react";
import "./SignaturePanel.component.css";
import DropDownSelect from "../../common/form-fields/drop-down/DropDownSelect";
import Helpers from "../../common/util/Helpers";

class SignaturePanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activePanel: "front"
        }
    }

    customizePlan() {
        this.setState({
            activePanel: "back"
        });
    }

    viewFront() {
        this.setState({
            activePanel: "front"
        });
    }

    renderCoinsurance() {

        let coinsuranceOptions = [];
        this.props.policyDetails.policies.map(policy => {
            if (policy.deductible < 1500) {
                if (!coinsuranceOptions.find(ele => ele.value === policy.reimbursement * 100)) {
                    let obj = { displayName: policy.reimbursement * 100 + "%", value: policy.reimbursement * 100 }
                    coinsuranceOptions.push(obj);
                }
            }
        });

        coinsuranceOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        if (coinsuranceOptions.length >=2) {

        return (
            <DropDownSelect
                style={{ width: "100%", backgroundColor: "#FFF" }}
                field="coinsurance"
                className=""
                id="signature_coinsurance"
                data={coinsuranceOptions}
                onChange={this.props.handleCoinsuranceChange.bind(this)}
                initialValue={this.props.tempSelectedCoinsurance}
            />
        )
        } else if (coinsuranceOptions.length === 1) {
            return (
                <div className="text-left single-reimbursement-text">
                    <p>{coinsuranceOptions[0].displayName}</p>
                </div>
            )
        } else {
            return (
                <div className="text-left">
                    No coinsurance options available
                </div>
            )
        }
    }

    renderDeductible() {

        let deductibleOptions = [];
        this.props.policyDetails.policies.map(policy => {
            if (policy.deductible < 1500) {
                if (!deductibleOptions.find(ele => ele.value === policy.deductible)) {
                    let obj = { displayName: "$" + policy.deductible, value: policy.deductible }
                    deductibleOptions.push(obj);
                }
            }
        });

        deductibleOptions.sort((op1, op2) => {
            if (op1.value > op2.value) return 1;
            return -1;
        })

        if (deductibleOptions.length >=2) {

        return (
            <DropDownSelect
                style={{ width: "100%", backgroundColor: "#FFF" }}
                field="deductible"
                className=""
                id="signature_deductible"
                data={deductibleOptions}
                onChange={this.props.handleDeductibleChange.bind(this)}
                initialValue={this.props.tempSelectedDeductible}
            />
        )
        } else if (deductibleOptions.length === 1) {
            return (
                <div className="text-left single-reimbursement-text">
                    <p>{deductibleOptions[0].displayName}</p>
                </div>
            )
        } else {
            return (
                <div className="text-center">
                    No deductible options available
                </div>
            )
        }
    }

    selectPlanType() {
        this.props.setSelectedPlanType("signature");
        this.viewFront();
    }

    render() {
        return (
            <div className="signature-panel">
                { this.state.activePanel === "front" && 
                <div id="signaturePanelFront" className={`row overflow-hidden signature-panel-front ${this.props.selectedPlanType === "signature" ? "selected" : ""}`}>
                    <div className="col text-center px-3 py-4 signature-panel-front-content">
                        <h3 className="text-center font-weight-bold signature-panel-front-title">Signature Plan</h3>
                        <p className="text-center signature-panel-front-description">
                            Coverage for accidents and illnesses, designed for life’s daily adventures and the surprises you can’t foresee. <span className="font-weight-bold">Lower deductibles mean payouts start sooner</span>.
                        </p>
                        <div className="d-block signature-panel-front-table">
                            <span className="font-weight-bold signature-panel-front-table-title">{Helpers.formatCurrency(this.props.selectedPremium)}</span>/month
                            <table className="text-start signature-panel-front-table-content">
                                <tbody>
                                    <tr>
                                        <td className="sub-heading">Reimbursement:</td>
                                        <td className="sub-value"><span className="font-weight-bold">{this.props.selectedCoinsurance}%</span></td>
                                    </tr>
                                    <tr>
                                        <td className="sub-heading">Annual Deductible:</td>
                                        <td className="sub-value"><span className="font-weight-bold">${this.props.selectedDeductible}</span></td>
                                    </tr>
                                    <tr>
                                        <td className="sub-heading">Maximum Payouts:</td>
                                        <td className="sub-value"><span className="font-weight-bold">Unlimited</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            {/*
                            <div className="text-start">
                                <a type="button" class="text-start font-weight-bold signature-panel-front-table-link">What do these terms mean?</a>
                            </div>
                            */}
                        </div>
                        <div className="signature-panel-front-table-content">
                                <a type="button" onClick={this.customizePlan.bind(this)} className="float-left buttonlink align-middle position-relative customize-plan" style={{ paddingLeft :"5px", textDecoration :"underline" , marginTop:"8px" }}>Customize Plan</a>
                            { this.props.selectedPlanType === "signature" ? 
                                (<button type="button" className="button-primary align-middle float-right button-plan-selected">Selected <img src="/assets/images/check-mark-white.png" className="ml-1 check-mark-white" /></button>) :
                                (<div onClick={this.selectPlanType.bind(this)} className="whiteBtn align-middle float-right">Select This Plan</div>)
                            }
                            <div className="clear-both"></div>
                        </div>
                    </div>
                </div> }
                { this.state.activePanel === "back" && 
                <div id="signaturePanelBack" className="row overflow-hidden signature-panel-back">
                    <div className="col text-center py-3 px-4 signature-panel-back-content">
                        <h3 className="text-center mb-0 font-weight-bold signature-panel-back-title">Customize the Signature Plan</h3>
                        <p className="d-block mb-0 mt-0">
                            <span className="font-weight-bold signature-panel-back-table-premium">{Helpers.formatCurrency(this.props.tempSelectedPremium)}</span>/month
                        </p>
                        <div className="d-block mx-auto mt-1 signature-panel-back-table-options">
                            <h4 className="text-left mb-1 signature-panel-back-table-title">Reimbursement Options</h4>
                            {
                                this.renderCoinsurance()
                            }
                            <h4 className="text-left mt-3 mb-1 signature-panel-back-table-title">Deductible Options</h4>
                            {
                                this.renderDeductible()
                            }
                        </div>
                        <div className="mt-3 px-3 signature-panel-back-table-content">
                            <a type="button" onClick={this.viewFront.bind(this)} className="float-left buttonlink align-middle position-relative mt-2" style={{textDecoration: 'underline', paddingTop:"15px" , marginLeft:"-15px"}}>&lt;Back</a>
                                <div onClick={this.selectPlanType.bind(this)} className="whiteBtn align-middle float-right" style={{marginTop:"15px" , marginRight:"-20px"}}>
                                Select This Plan
                            </div>
                        </div>
                    </div>
                </div> }
                {/*}
                <div id="termMeaningsPanel" className="row overflow-hidden signature-panel-terms">
                    <div className="row pe-0 pt-3">
                        <div className="col pe-1">
                            <img src="/Images/V3/funnel/modal-close.png" className="ms-1 float-end signature-panel-terms-close" />
                        </div>
                    </div>
                    <img src="/Images/V3/funnel/modal-close.png" className="signature-panel-terms-close" />
                    <span className="fw-bold text-center mb-3 signature-panel-terms-title">Pet Insurance Terms</span>
                    <p className="signature-panel-terms-description">
                        <span className="fw-bold">REIMBURSEMENT</span>
                        What you'll get back from your claim after your annual deductible is met.  Unlike some pet insurance companies, Healthy Paws will reimburse you based on your actual vet bill, as opposed to
                        some plans that only reimburse based on what they think the treatment for a specific condition should cost.
                    </p>
                    <p className="signature-panel-terms-description">
                        <span className="fw-bold">ANNUAL DEDUCTIBLE</span>
                        The amount you'll pay out-of-pocket each year before your plan begins to cover medical costs for your pet(s).
                    </p>
                    <p className="signature-panel-terms-description">
                        <span className="fw-bold">MAXIMUM PAYOUT</span>
                        Unlike some pet insurance plans, the Healthy Paws plan has <span className="fw-bold">no limits on claim payouts per incident, per year or for the lifetime of the policy</span>.
                    </p>
                </div>
                */}
            </div>
        )
    }
}



export default SignaturePanel;